import React from 'react';
import TickIcon from './Icons/Tick';
import { hexToRgb } from '../../styles/utils';
export const getFontStyles = ({ theme }) => {
    const { type140 } = theme.typography;
    return Object.assign(Object.assign({}, type140), { color: theme.colors.textInversePrimary });
};
export const getBorderStyles = ({ theme }) => {
    const border = theme.borders.border100;
    const borderRadius = theme.borders.radius30;
    return Object.assign(Object.assign({}, border), { borderRadius });
};
export const getBackground = ({ checked, theme, disabled }) => {
    if (checked) {
        if (disabled) {
            return theme.colors.surface50;
        }
        return theme.colors.secondary;
    }
    return theme.colors.surface20;
};
export const getTitleStyles = ({ theme }) => {
    const { type141, } = theme.typography;
    return Object.assign({}, type141);
};
export const getSwitchStyle = ({ checked }) => {
    const style = {
        right: '3px',
        top: '3px',
    };
    if (!checked) {
        return {
            left: '1.5px',
            top: '1.5px',
            boxShadow: '0px 2px 3px rgba(0, 19, 37, 0.16)',
        };
    }
    return Object.assign({}, style);
};
export const getButtonFontStyles = ({ theme }) => {
    const { type142 } = theme.typography;
    return Object.assign({}, type142);
};
export const getIcon = () => React.createElement(TickIcon, null);
export const getHoverColor = ({ checked, theme }) => {
    if (checked) {
        return hexToRgb(theme.colors.secondary, 0.16);
    }
    return hexToRgb(theme.colors.state, 0.08);
};
export const getActiveColor = ({ checked, theme }) => {
    if (checked) {
        return hexToRgb(theme.colors.secondary, 0.24);
    }
    return hexToRgb(theme.colors.state, 0.16);
};
export const getBorderStyle = ({ checked, theme }) => {
    const style = {};
    if (!checked) {
        style.border = `1.5px solid ${hexToRgb(theme.colors.textPrimary, 0.16)}`;
    }
    return Object.assign({}, style);
};
export const getHoverStyle = ({ checked, theme, disabled }) => {
    const style = {};
    if (!disabled) {
        style.boxShadow = `0 0 0 10px ${getHoverColor({ checked, theme })}`;
    }
    return Object.assign({}, style);
};
